<template>
  <div class="home full-height bg-image yxsl-banner">
    <ld-statusbar />

    <van-row
      class="white list"
      type="flex"
      align="center"
    >
      <van-col
        span="20"
        class="logo font18"
      >
        <!-- {{ loginConfig.pageName }} -->
      </van-col>
      <van-col span="4">
        <div
          class="server text-center"
          @click="$router.push({ path: '/service' })"
        >
          <van-icon
            class="font24"
            name="service"
          />
          <div class="font12">
            {{ $t('A022','专属客服') }}
          </div>
        </div>
      </van-col>
    </van-row>

    <div class="yxslhomewrapper">
      <mescroll-vue
        ref="mescroll"
        :down="{ use: false }"
      >
        <div class="list font18 white">
          {{ $t('A029','欢迎您') }}，{{ userInfo.empInfo && userInfo.empInfo.empName }}
        </div>
        <div class="list">
          <!-- mode="closeable" -->
          <van-notice-bar
            v-if="loginNotices && loginNotices.length"
            class="full-width round-md"
            left-icon="bullhorn-o"
            style="height: 28px;"
            color="#ffffff"
            background="#417eff"
          >
            <span
              v-for="notice in loginNotices"
              :key="notice.id"
              @click="$router.push({ path: `/userCenter/noticeDetail/${notice.id}` })"
              style="margin-left: 30px"
            >
              {{ notice.content }}
            </span>
          </van-notice-bar>
        </div>

        <!-- Menu -->
        <div class="list">
          <van-cell
            class="round-md bg-image banner-empty"
            v-show="orderList.length==0"
            style="height:90px;"
            @click="$router.push({path:'/allorder?findType=3'})"
          >
            <div style="padding:10px;">
              <div class="font20 font-bold main-color">
                GOOD JOB
              </div>
              <div class="gray ">
                所有待办都已完成
              </div>
            </div>
          </van-cell>
          <van-swipe
            class="round-md bg-white"
            :autoplay="5000"
            v-show="orderList.length"
            height="170"
          >
            <van-swipe-item
              v-for="(item,index) in orderList"
              :key="index"
              @click="toDetail(item)"
            >
              <div v-show="item.orderType==11007">
                <van-cell>
                  <div class="font20 font-bold main-color">
                    待入住
                  </div>
                  {{ item.rzrxm }}  {{ item.rzrq }} {{ item.cityName }}
                </van-cell>
                <van-cell>
                  <van-row
                    type="flex"
                    align="center"
                  >
                    <van-col span="6">
                      <img src="">
                    </van-col>
                    <van-col
                      span="18"
                      class="text-left"
                    >
                      <div>{{ item.jdmc }}</div>
                      <div>{{ item.address }}</div>
                      <div>{{ item.rzrq }}入住  {{ item.ldrq }}离店</div>
                    </van-col>
                  </van-row>
                </van-cell>
              </div>
              <div v-if="item.orderType==11001||item.orderType==11004">
                <van-cell>
                  <div class="font20 font-bold main-color">
                    待出行
                  </div>
                  {{ item.psgName }}  {{ item.orderRangeBeanList[0].departDate }} {{ item.orderRangeBeanList[0].departCityName }}
                </van-cell>
                <van-cell>
                  <van-row
                    type="flex"
                    align="center"
                  >
                    <van-col span="8">
                      <div class="font16">
                        {{ item.orderRangeBeanList[0].departCityName }}
                      </div>
                      <div class="font24 font-bold">
                        {{ item.orderRangeBeanList[0].departTime }}
                      </div>
                      <div class="gray">
                        {{ item.orderRangeBeanList[0].departAirportName }}
                      </div>
                    </van-col>
                    <van-col
                      span="8"
                      class="text-center"
                    >
                      <img :src="tk_link">
                    </van-col>
                    <van-col
                      span="8"
                      class="text-right"
                    >
                      <div class="font16">
                        {{ item.orderRangeBeanList[0].arriveCityName }}
                      </div>
                      <div class="font24 font-bold">
                        {{ item.orderRangeBeanList[0].arriveTime }}
                      </div>
                      <div class="gray">
                        {{ item.orderRangeBeanList[0].arriveAirportName }}
                      </div>
                    </van-col>
                  </van-row>
                </van-cell>
              </div>
              <div v-show="item.orderType==11009">
                <van-cell>
                  <div class="font20 font-bold main-color">
                    待出行
                  </div>
                  {{ item.passengerNames }}  {{ item.fromDate }} {{ item.fromTime }} {{ item.fromWeek }}
                </van-cell>
                <van-cell>
                  <van-row
                    type="flex"
                    align="center"
                  >
                    <van-col span="8">
                      <div class="font16">
                        {{ item.fromCityName }}
                      </div>
                      <div class="font24 font-bold">
                        {{ item.fromTime }}
                      </div>
                      <div class="gray">
                        {{ item.fromStationName }}
                      </div>
                    </van-col>
                    <van-col
                      span="8"
                      class="text-center"
                    >
                      <img :src="tr_link">
                    </van-col>
                    <van-col
                      span="8"
                      class="text-right"
                    >
                      <div class="font16">
                        {{ item.toCityName }}
                      </div>
                      <div class="font24 font-bold">
                        {{ item.toTime }}
                      </div>
                      <div class="gray">
                        {{ item.toStationName }}
                      </div>
                    </van-col>
                  </van-row>
                </van-cell>
              </div>
            </van-swipe-item>
          </van-swipe>
        </div>
        <!--  -->
        <div class="list">
          <div class="container bg-white round-md">
            <van-cell
              v-for="tab in menuList"
              :key="tab.link"
              :class="[tab.openDiasble ? 'menu-disabled' : '']"
              @click="to(tab)"
            >
              <van-row
                type="flex"
                align="center"
              >
                <van-col
                  span="4"
                >
                  <van-image
                    v-lazy
                    width="40"
                    :src="tab.img"
                  />
                </van-col>
                <van-col span="20">
                  <div class="font16 font-md">
                    {{ $t(tab.title) }}
                  </div>
                  <div class="gray">
                    {{ tab.label }}
                  </div>
                </van-col>
              </van-row>
            </van-cell>
          </div>
        </div>

        <!--  -->
        <div class="list">
          <van-cell class="round-md">
            <van-row
              type="flex"
              align="center"
              class="text-center"
            >
              <van-col
                span="6"
                v-for="(item,index) in menuList_other"
                :key="index"
                @click="to(item)"
                :class="[item.openDiasble ? 'menu-disabled' : '']"
              >
                <div style="height:30px">
                  <van-image
                    lazy-load
                    width="30"
                    height="30"
                    :src="item.img"
                    class="full-width"
                  />
                </div>
                <div class="font14 font-md">
                  {{ item.title }}
                </div>
              </van-col>
            </van-row>
          </van-cell>
          <!-- <van-grid
              :column-num="4"
              :border="false"
              style="flex-wrap: nowrap;"
            >
              <van-grid-item
                v-for="(item,index) in menuList_other"
                :key="index"
                :to="item.link"
                :url="item.url"
              >
                <template #icon>
                  <van-image
                    v-lazy
                    width="40"
                    :src="item.img"
                  />
                </template>
                <template #text>
                  <span
                    class="van-grid-item__text"
                    :style="{ color: item.disabled && '#ccc' }"
                  >{{ item.title }}</span>
                </template>
              </van-grid-item>
            </van-grid> -->
        </div>
      </mescroll-vue>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { Tabbar, TabbarItem ,Popup, Grid, GridItem, Icon, NoticeBar ,Image as VanImage,Cell,Swipe, SwipeItem} from 'vant'
import { update } from 'CommonUtils/updateApp.js'
import MescrollVue from 'mescroll.js/mescroll.vue'
import { getRelativeDate } from 'Utils/dateUtil'
import Bussiness from 'Utils/business'
import ldStatusbar from 'Common/ldStatusbar'

import menu_tk from 'Components/Dynamic/yxsl/images/menu/tk.png'
import menu_ht from 'Components/Dynamic/yxsl/images/menu/ht.png'
import menu_tr from 'Components/Dynamic/yxsl/images/menu/tr.png'
import menu_car from 'Components/Dynamic/yxsl/images/menu/car.png'
import menu_visa from 'Components/Dynamic/yxsl/images/menu/visa.png'

import menu_checkIn from 'Components/Dynamic/yxsl/images/menu/checkIn.png'
import menu_fastCheck from 'Components/Dynamic/yxsl/images/menu/fastCheck.png'
import menu_guestPass from 'Components/Dynamic/yxsl/images/menu/guestPass.png'
import menu_restRoom from 'Components/Dynamic/yxsl/images/menu/restRoom.png'

import menu_strategy from 'Assets/images/home/menu_strategy.png'
import menu_discount from 'Assets/images/home/menu_discount.png'
import menu_freebus from 'Assets/images/home/menu_freebus.png'
import menu_contracthotel from 'Assets/images/home/menu_contracthotel.png'
import menu_policy from 'Assets/images/home/menu_policy.png'

import tk_link from 'Components/Dynamic/yxsl/images/home/tk-link.png'
import tr_link from 'Components/Dynamic/yxsl/images/home/tr-link.png'
import homeMixin from '../default/homeMixin'

export default {
  name: 'Home',
  mixins: [homeMixin],
  components: {
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Popup.name]: Popup,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Icon.name]: Icon,
    [NoticeBar.name]: NoticeBar,
    [VanImage.name]: VanImage,
    [Cell.name]: Cell,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    MescrollVue,
    ldStatusbar
  },
  data () {
    return {
      tk_link,
      tr_link,
      menuList: [
        {
          link: '/tk/tkQuery',
          title: 'A008',//机票
          img: menu_tk,
          label:'低价机票，舒适出行',
          PRO_TYPE: 10901,
        },
        {
          link: '/ht/htQuery',
          title: 'A009',//酒店
          img: menu_ht,
          label:'尊贵入住，商旅独享',
          PRO_TYPE: 10903,
        },
        {
          link: '/tr/trQuery',
          title: 'A010',//火车票
          img: menu_tr,
          label:'舒适高铁，在线选座',
          PRO_TYPE: 10904,
        },
        {
          link: '/car/carQuery',
          title: 'A011',//用车
          img: menu_car,
          label:'晚点必等，安心出行',
          PRO_TYPE: 10906,
        },
        {
          link: '/visa',
          title: 'A012',//签证
          img: menu_visa,
          label:'全国受理，一对一辅导',
          openDiasble: true,
          PRO_TYPE: 10913,
        }
      ],
      menuList_minor: [
        {
          link: '/tkIntel/policy',
          title: 'A019',//'国际特惠',
          img: menu_strategy
        },
        {
          link: '/tk/policy',
          title: 'A020',//'协议直减',
          img: menu_discount
        },
        {
          link: '/tk/airportBus',
          title: 'Q016',//机场大巴
          img: menu_freebus
        },
        {
          link: '/ht/htQuery/htSignList',
          title: 'A021',//'协议酒店',
          img: menu_contracthotel
        },
        {
          link: '/tk/strategy',
          title: 'Q007',//机场攻略
          img: menu_policy,
          openDiasble: true
        },
      ],
      menuList_other: [
        {
          link: '/checkIn',
          title: '优先值机',
          img: menu_checkIn,
          PRO_TYPE: 10916,
        },
        {
          link: '/guestPass',
          title: '要客通',
          img: menu_guestPass,
          PRO_TYPE: 10917,
        },
        {
          link: '/fastCheck',
          title: '快速安检',
          img: menu_fastCheck,
          PRO_TYPE: 10915,
        },
        {
          link: '/restRoom',
          title: '休息室',
          img: menu_restRoom,
          PRO_TYPE: 10914,
        },
        // {
        // 	link: '/home',
        // 	title: '敬请期待',
        // 	icon: 'iconweibiaoti-24',
        // 	color:'#248aff',
        // 	disabled: true
        // }
      ],
      params:{
        dateStart: getRelativeDate(-30),
        dateEnd: getRelativeDate(0),
        dateType: '1', // 1 预订日期,2 是出发/入住日期
        findScope: '1', // 1是个人订单,2是全部订单 ,
        findType: '3',// 1全部订单 2待支付 3待出行 4退改 5指定的业务订单（productType必须传值）
        productType: '',//产品类型
        tripType: '',
        pageNum: 1, 
        count: 30
      },
      orderList:[]
    }
  },
  created () {
    this.getLoginNotice(0) //获取登录公告
    this.getBadgeCount()
    this.checkOpenId()
  },
  async mounted () {
    this.getOrderList()

    await this.getAuthorizationPnos()
    this.genMenu([...this.menuList, ...this.menuList_other])
  },
  methods:{
    getOrderList(){
      var bool=0
      this.$api['common/allOrderList'](this.params).then(res => {
        var cache = res.data || {}
        var list=cache.list||[]
        list.forEach(el => {
          if(el.orderStatus==7){
            el.isShow=false
          }else{
            if(bool<=3){
              this.getDetail(el)
              bool+=1
            }
          }
        })
      }).catch(() => {
      })
    },
    getDetail(el){
      if(el.orderType==11001||el.orderType==11004){
        this.$api['tkOrder/orderDetail']({
          id:el.id
        }).then(res => {
          let cache=res.data||{}
          cache.orderType=el.orderType
          this.orderList.push(cache)
        }).catch(res =>{
          this.$toast(res.errMsg)
        })
      }else if(el.orderType==11007){
        this.$api['htQuery/hotelOrderDetail']({
          orderId: el.id
        }).then(res => {
          let cache=res.data||{}
          cache.orderType=el.orderType
          this.orderList.push(cache)
        })
      }else if(el.orderType==11009){
        this.$api['trOrder/detail']({ id :el.id}).then(res=>{
          let cache=res.data||{}
          cache.orderType=el.orderType
          this.orderList.push(cache)
        })
      }
    },
    toDetail(item){
      Bussiness.toOrderDetail(item)
    }
  },
  beforeRouteLeave (to, from, next) {
    // 导航离开该组件的对应路由时调用
    // 可以访问组件实例 `this`
    
    next()
  },
}
</script>

<style lang="less" scoped>

.home {
    position: relative;
    padding: 10px;
	background-size: cover;
	.logo {
		img {
            width: 57px;
		}
	}
    .list{
        padding-bottom: 10px;
    }
    .container{
        padding: 4px;
    }
    .server {
        div{
            margin-top: -5px;
        }
    }
    .yxslhomewrapper{
        height: calc(100vh - 106px);
        overflow: hidden;
    }

}
    .yxsl-banner{
        background-image: url('~Components/Dynamic/yxsl/images/bg.png');
    }
    .banner-empty{
        background-image: url('~Components/Dynamic/yxsl/images/banner-empty.png');
    }

</style>
